<template>
  <div>
    <h1>Плановые платежи</h1>

    <!-- <b-table striped hover :items="items"></b-table> -->
    <tableOperations :items="items"
      @update-operations-table="getItems( operationDefault.task )"
    />
    <b-button @click="getItems(operationDefault.task)">Обновить данные</b-button>

    <h5>Добавить плановый платеж</h5>
    <div><addOperation
          v-bind:operationDefault="operationDefault"
          mode="add"
          @update-operations-table="getItems( operationDefault.task )"
     /></div>

     <!-- <p>{{placementInfo}}</p>
     <p>operationDefault: <br>{{operationDefault}}</p> -->

  </div>
</template>

<script>
import addOperation from '../components/addOperations.vue'
import tableOperations from '../components/tableOperations.vue'
export default {
  components: {
    addOperation,
    tableOperations
  },
    data() {
    return {
      placementInfo: 'placementInfo',
      operationDefault: {
        task: null,
        deal: null,
        company: null,
      },
      items: [],
    }
  },
  async mounted() {

      this.getItems( this.operationDefault.task )

  },
  methods: {
    getItems ( taskId = null ) {
      // Фильтр на основе текущего места вызова, фильтрация по property
      let payload = {
            ENTITY: 'accrual',
            FILTER: {
              // PROPERTY_TASK: this.operationDefault.taskId
            },
      }
      this.$store.dispatch( 'getItems', payload, { root: true } )
      .then (result => {
          // console.dir(result);
          this.items = []
          result.map ( item => {
              this.items.push (
              {
                  'status': item.PROPERTY_VALUES.status,
                  'user': item.PROPERTY_VALUES.user,
                  'contact': item.PROPERTY_VALUES.contact,
                  'reference': item.PROPERTY_VALUES.reference,
                  'amount': item.PROPERTY_VALUES.amount,
                  'typeOfPayment': item.PROPERTY_VALUES.typeOfPayment,
                  'dataSort': item.PROPERTY_VALUES.dataSort,
                  'task': item.PROPERTY_VALUES.task,
                  'deal': item.PROPERTY_VALUES.deal,
                  'company': item.PROPERTY_VALUES.company,
                  'id': item.ID
              })

          })
      })
    }
  },
}
</script>